export const redirect = () => {
    const pastPost = document.querySelector('[data-redirect]');
    if (!pastPost) return;
    window.location.href = '/';
};
